import { Route, Routes } from 'react-router-dom';
import CommonLayout from '@/components/layout/CommonLayout';
import CompletedOrderListPage from '@/pages/completed-order-list/CompletedOrderListPage';
import CustomerServiceCenterPage from '@/pages/customer-center/CustomerCenterPage';
import MainPage from '@/pages/main/MainPage';
import OrderListPage from '@/pages/order-list/OrderListPage';
import MyPlayerListPage from '@/pages/my-player-list/MyPlayerListPage';
import BusinessProfilePage from '@/pages/business-profile/BusinessProfilePage';
import ServiceRegistration from '@/pages/service-registration/ServiceRegistrationPage';
import NotFound from '@/pages/error/NotFound';

function PartnerRoutes() {
  return (
    <Routes>
      <Route element={<CommonLayout />}>
        {/* 메인 페이지 */}
        <Route path="/main" element={<MainPage />} />
        {/* 주문 목록 페이지 */}
        <Route path="/order/orderList" element={<OrderListPage />} />
        {/* 완료된 주문 목록 페이지 */}
        <Route
          path="/order/completedOrderList/:page?"
          element={<CompletedOrderListPage />}
        />
        {/* 나의 플레이어 목록 페이지 */}
        <Route path="/my-player-list" element={<MyPlayerListPage />} />
        {/* 비지니스 프로필 페이지 */}
        <Route path="/business-profile" element={<BusinessProfilePage />} />
        {/* 서비스 등록 페이지 */}
        <Route path="/service-registration" element={<ServiceRegistration />} />
        {/* 고객센터 페이지 */}
        <Route
          path="/support/customerServiceCenter"
          element={<CustomerServiceCenterPage />}
        />
      </Route>
      <Route path="/*" element={<NotFound />} />
      {/* 추가 partner 라우트 */}
    </Routes>
  );
}

export default PartnerRoutes;
